import React, { useState } from "react";
import MainModal from "components/ModalMain";
import Button from "components/Button";
import Input from "components/Input";
import { useMutation } from "@apollo/client";
import { UPDATE_STAFF_PIN } from "graphql/service";
import { Head, Container, Footer } from "./styles";
import { message } from "antd";

const ModalChangePIN = ({
  hidden,
  buttonStyle,
  staffId
}) => {

  const [isOpen, setIsOpen] = useState(false);
  const [currentPINEntered, setCurrentPINEntered] = useState(false);
  const [currentPIN, setCurrentPIN] = useState("");
  const [newPIN, setNewPIN] = useState("");
  const [currentPINError, setCurrentPINError] = useState(false);
  const [newPINError, setNewPINError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [updateStaffPIN, { loading }] = useMutation(UPDATE_STAFF_PIN, {
    onCompleted: (data) => {
      message.success("PIN updated successfully!");
      setIsOpen(false);
      setCurrentPIN("");
      setNewPIN("");
      setCurrentPINEntered(false);
      setCurrentPINError(false);
      setNewPINError(false);
    },
    onError: (error) => {
      let messages = [];

      if (error.graphQLErrors?.length > 0) {
        messages = error.graphQLErrors.map(err => err.message);
      } else if (error.networkError?.result?.errors) {
        messages = error.networkError.result.errors.map(err => err.message);
      } else if (error.networkError) {
        messages = [error.networkError.message];
      }

      if (messages?.length > 0) {
        const finalMessage = messages.join(", ")
        if(finalMessage.includes("current")) {
          setCurrentPINError(true);
          setErrorMessage(finalMessage);
          setNewPINError(false);
          setNewPIN("");
          setCurrentPINEntered(false);
        } else {
          setNewPINError(true);
          setErrorMessage(finalMessage);
        }
      }
    }
  });

  const handleContinue = () => {
    if (currentPIN.trim() === "" || currentPIN.length !== 6) {
      setCurrentPINError(true);
      return;
    }
    setCurrentPINEntered(true);
  };

  const handleChangePIN = () => {
    if (loading) return;
    if (newPIN.trim() === "" || newPIN.length !== 6) {
      setNewPINError(true);
      return;
    }
    updateStaffPIN({
      variables: {
        staffId: staffId, 
        input: {
          currentPin: currentPIN,
          pin: newPIN
        }
      }
    });
  };

  return (
    <>
      <MainModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        setClose={() => {
          setIsOpen(false);
          setCurrentPIN("");
          setNewPIN("");
          setCurrentPINEntered(false);
          setCurrentPINError(false);
          setNewPINError(false);
        }}
        className="modal-success"
        buttonLabel="Change PIN"
        buttonStyle={buttonStyle}
        hidden={hidden}
        additionalstyle={`
          max-width: 500px;
          .modal-content{
            .close {
              z-index: 200;
            }          
            .modal-body {
              height: 100%;
              padding: 24px;
            }
          }
          top: 139px;
        `}
      >
        <Head>
          {currentPINEntered ? "Enter New PIN" : "Enter Current PIN"}
        </Head>
        <Container>
          {currentPINEntered? <Input
            title="6-DIGIT PIN"
            required
            maxLength={6}
            error={newPINError}
            errorMessage={errorMessage}
            value={newPIN}
            onChange={(e) => {
              const result = e.target.value.replace(/\D/g, "");
              setNewPIN(result);
              setNewPINError(false);
            }}
            additionalstyle={`
            width: 100%;
          `}
          />: <Input
            title="6-DIGIT PIN"
            required
            maxLength={6}
            error={currentPINError}
            errorMessage={errorMessage}
            value={currentPIN}
            onChange={(e) => {
              const result = e.target.value.replace(/\D/g, "");
              setCurrentPIN(result);
              setCurrentPINError(false);
            }}
            additionalstyle={`
            width: 100%;
          `}
          />}
        </Container>
        <Footer>
          <Button
            success
            additionalstyle={`
              width: 97px;
            `}
            onClick={currentPINEntered ? handleChangePIN : handleContinue}
            data-loading={loading}
          >
            {loading ? null : "Continue"}
          </Button>
        </Footer>
      </MainModal>
    </>
  );
};

export default ModalChangePIN;